<div class="app-document-upload-preview" *ngIf="!isDocumentUploaded && type === 'standard'">
  <div
    [ngClass]="{
      focused: isShowMultipleFileOptions,
      'is-uploading': isLoading || isUploadingDoc || isDocumentScanPending,
      'is-drag-over': isDragOver
    }"
    [class]="'app-document-upload-preview__box ' + (!(isLoading || isUploadingDoc || isDocumentScanPending) ? tagType : '')"
    (click)="uploadClick()"
  >
    <span *ngIf="!(isLoading || isUploadingDoc || isDocumentScanPending)" [class]="'app-document-upload-preview__tag ' + tagType">
      {{ tagText | translate }}
      <app-hint-tooltip-icon *ngIf="tagTooltip" [hint]="tagTooltip | translate"></app-hint-tooltip-icon>
    </span>
    <div class="app-document-upload-preview__box__center-actions">
      <div class="app-document-upload-preview__add-button-container">
        <div class="app-document-upload-preview__add-button-container__inner-container">
          <border-spinner *ngIf="isLoading || isUploadingDoc || isDocumentScanPending" loaderClass="sm-loader"></border-spinner>
          <img class="app-document-upload-preview__add-button" src="assets/icons/icon_add_lg.svg" alt="add" />
          <span
            *ngIf="isLoading || isUploadingDoc || isDocumentScanPending"
            class="app-document-upload-preview__add-button-container__label"
          >
            {{ uploadingStatusText | translate | uppercase }}...
          </span>
        </div>
      </div>
      <div *ngIf="shouldShowDeleteButton" (click)="onDelete($event)">
        <div
          nz-tooltip
          nzTooltipColor="#ffffff"
          nzTooltipPlacement="top"
          nzTooltipOverlayClassName="normalize"
          [nzTooltipTitle]="'BUTTON.DELETE' | translate"
          class="app-document-upload-preview__delete-button"
        >
          <img src="assets/icons/icon_trash.svg" alt="delete" />
        </div>
      </div>
    </div>
  </div>
  <p *ngIf="!!labelText" class="app-document-upload-preview__label">{{ labelText | translate }}</p>
</div>

<div class="app-document-upload-preview" *ngIf="!isDocumentUploaded && type === 'multiple'">
  <div
    [ngClass]="{
      focused: isShowMultipleFileOptions,
      'is-uploading': isLoading,
      'is-drag-over': isDragOver
    }"
    [class]="'app-document-upload-preview__box ' + (!isLoading ? tagType : '')"
    (click)="uploadClick()"
  >
    <div class="app-document-upload-preview__box__options" *ngIf="isShowMultipleFileOptions">
      <span
        class="app-document-upload-preview__box__option"
        *ngFor="let option of multipleFileOptions"
        (click)="multipleFileUploadClick(option.value)"
      >
        {{ option.label | translate }}
      </span>
    </div>

    <ng-container *ngIf="!isShowMultipleFileOptions">
      <span *ngIf="!isLoading" [class]="'app-document-upload-preview__tag ' + tagType">
        {{ tagText | translate }}
      </span>
      <div class="app-document-upload-preview__add-button-container">
        <div class="app-document-upload-preview__add-button-container__inner-container">
          <border-spinner *ngIf="isLoading" loaderClass="sm-loader"></border-spinner>
          <img class="app-document-upload-preview__add-button" src="assets/icons/icon_add_lg.svg" alt="add" />
          <span *ngIf="isLoading" class="app-document-upload-preview__add-button-container__label">
            {{ uploadingStatusText | translate | uppercase }}...
          </span>
        </div>
      </div>
    </ng-container>
  </div>
  <p *ngIf="!!labelText" class="app-document-upload-preview__label">{{ labelText | translate }}</p>
</div>

<div class="app-document-upload-preview" *ngIf="isDocumentUploaded">
  <div class="app-document-upload-preview__box is-uploaded" [style.background-image]="documentPreviewUrl">
    <loading-spinner [show]="isLoading"></loading-spinner>

    <div class="app-document-upload-preview__box__actions">
      <div
        nz-tooltip
        nzTooltipColor="#ffffff"
        nzTooltipPlacement="top"
        nzTooltipOverlayClassName="normalize"
        [nzTooltipTitle]="'BUTTON.PREVIEW' | translate"
        class="app-document-upload-preview__preview-button"
        [ngClass]="{ disabled: !documentPreviewUrl }"
        (click)="onPreviewDocument()"
      >
        <img src="assets/icons/icon_eye_gray_sm.svg" alt="preview" />
      </div>

      <div
        *ngIf="canDelete"
        nz-tooltip
        nzTooltipColor="#ffffff"
        nzTooltipPlacement="top"
        nzTooltipOverlayClassName="normalize"
        [nzTooltipTitle]="'BUTTON.DELETE' | translate"
        class="app-document-upload-preview__delete-button"
        (click)="onDelete($event)"
      >
        <img src="assets/icons/icon_trash.svg" alt="delete" />
      </div>
    </div>
  </div>
  <p *ngIf="!!labelText" class="app-document-upload-preview__label">{{ labelText | translate }}</p>
</div>

<input
  #inputElement
  class="d-none"
  type="file"
  [id]="id"
  [accept]="allowedFileMimes"
  (click)="clickInput()"
  (change)="handleFiles($event)"
  [disabled]="isDocumentUploaded && !!fileName"
/>

<custom-toast type="alert" [message]="errorMessage" [duration]="0" [open]="isShowInvalidFileToast" (close)="onCloseInvalidFileToast()">
  <button action-button class="custom-toast__action-button btn btn-link-outlined" (click)="onReplace()">
    {{ "BUTTON.REPLACE" | translate }}
  </button>
</custom-toast>
